import { initAmplitude, initPageViewAnalytics } from ':fat/init/amplitude';
import { identifyDevice } from ':fat/init/identify';

export function initAnalytics() {
  // init amplitude
  initAmplitude();

  // init identity
  identifyDevice();

  // init page view tracking
  initPageViewAnalytics();
}
